var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.products.length
    ? _c("div", { staticClass: "product-cross-sell" }, [
        _c("h2", {
          staticClass: "product-cross-sell__title",
          domProps: {
            innerHTML: _vm._s(_vm.$t("shoplist.product.crossSellTitle")),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "product-cross-sell__products" },
          _vm._l(_vm.productsEnhanced, function (product, index) {
            return _c("ShoplistProduct", {
              key: product.code,
              attrs: {
                product: product,
                locked: _vm.lockedProducts[product.code],
              },
              on: {
                addToCart: _vm.onAddToCart,
                config: _vm.onConfig,
                click: _vm.onClickProduct,
              },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }